import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRedCloseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 47,
	viewBox: "0 0 43 47",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 25.891,
			cy: 29.7727,
			rx: 3.76599,
			ry: 3.65553,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 21,
			cy: 26.2958,
			rx: 17,
			ry: 16.8935,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 39.5318,
			cy: 39.1658,
			rx: 2.53176,
			ry: 2.61109,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.0127,
			cy: 45.9546,
			rx: 1.0127,
			ry: 1.04444,
			fill: "#E34C4C"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 28.0127,
			cy: 1.04444,
			rx: 1.0127,
			ry: 1.04444,
			fill: "#FC6B6B"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.5,
			cy: 7.83375,
			rx: 2.5,
			ry: 2.61109,
			fill: "#FFE6E6"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 44.4971C28.9 44.4971 37 36.4479 37 26.6099C37 16.7719 28.9 8.72266 19 8.72266C9.1 8.72266 1 16.7719 1 26.6099C1 36.4479 9.1 44.4971 19 44.4971Z",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 19.2324L27 35.3126",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 35.3126L27 19.2324",
			stroke: "#E34C4C",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgRedCloseIcon;
